import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import MediaUploadModal from 'pages/widgets/form/media-upload'

const MediaAddButton = styled.div`
  position: absolute;
  top: 9px;
  right: 12px;
  cursor: pointer;

  > i {
    font-size: 18px;
  }
`

const MediaAddButtonIndicator = styled.div`
  background-color: #45b6af;
  color: white;
  width: 16px;
  height: 16px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -5px;
  right: -7px;
`
class MediaUploadButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      show: false
    }
    this.handleShow = this.handleShow.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleShow () {
    this.setState({ show: true })
  }

  handleClose () {
    this.setState({ show: false })
  }

  render () {
    const { value, onChange } = this.props.input
    const count = value.length
    const indicator = count || <i className='fa fa-plus' />

    return (
      <MediaAddButton className='br-media-upload-btn' onClick={this.handleShow}>
        <i className='fa fa-image' />
        <MediaAddButtonIndicator className='br-media-btn-indicator'>
          {indicator}
        </MediaAddButtonIndicator>
        <MediaUploadModal
          showModal={this.state.show}
          hideModal={this.handleClose}
          onChange={onChange}
          value={value}
          isDM={this.props.isDM}
        />
      </MediaAddButton>
    )
  }
}

MediaUploadButton.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  input: PropTypes.any,
  isDM: PropTypes.bool
}

export default MediaUploadButton



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/media/media-upload.js